import {
  Component,
  EventEmitter,
  Input,
  model,
  Output,
  ViewChild,
} from '@angular/core';
import { Select } from 'primeng/select';

@Component({
    selector: 'c-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrl: './dropdown.component.css',
    standalone: false
})
export class DropdownComponent {
  showPanel = false;
  option = model.required<any>();
  @Input() options: any[] = [];
  @Input() propiedad!: string;
  @Input() filtrar!: boolean;
  @Input() limpiar!: boolean;
  @Input() etiqueta = 'Inserte etiqueta';
  @Input() placeholder = 'Inserte placeholder';
  @Input() id = '';
  @Input() descripcionLabel!: string | null;
  @Input() setFirstValue = true;
  @Input() readonly = false;
  @Input() group = false;
  @Output() onFilter = new EventEmitter<string>();
  @Output() onScroll = new EventEmitter<any>();

  @ViewChild('dropdown') dropdown!: Select;

  ngAfterViewInit() {
    if (this.setFirstValue) this.option.set(this.options[0]);
  }

  @Input() multiple = false;

  /** Permite linkear una variable bool, para mostrar los mensajes de error, desaparece si el usuario
   * ingresa el valor */
  @Input() showError = false;
  @Input() mensajeError = '';
}
